export default __webpack_public_path__ + "18d00f739ff1e1c52db1a1c0d9e98129.woff";